import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import OrderUpdateModalUI from './OrderUpdateModalUI.js'

class OrderUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: null,
      // update order
      submitted: false,
      // order name
      orderName: this.props.order.orderName,
      orderNameError: null,
      // dueDate
      dueDate: this.props.order.dueDateISO,
      dueDateError: null,
    }
  }

  render() {
    return (
      <OrderUpdateModalUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        // update mode
        updateMode={this.props.updateMode}
        // order name
        orderName={this.state.orderName}
        onOrderNameChange={(event) => {this.setState({orderName: event.target.value})}}
        orderNameError={this.state.orderNameError}
        setOrderNameError={(error) => {this.setState({orderNameError: error})}}
        // dueDate
        dueDate={this.state.dueDate}
        onDueDateChange={(selectedDateISO) => {
          this.setState({dueDate: selectedDateISO})
        }}
        dueDateError={this.state.dueDateError}
        setDueDateError={(error) => {this.setState({dueDateError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
        onCancelClick={this.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/orders/${this.props.match.params.orderId}`,
      this.onSubmitCallback, {
        orderName: this.state.orderName,
        dueDate: this.state.dueDate,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'orderName':
          this.setState({orderNameError: error.message})
          break;
        case 'dueDate':
          this.setState({dueDateError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
      }, 2000)
      this.props.onUpdateComplete(response.order)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  onCancelClick = () => {
    // reset everything
    this.setState({
      successMsg: null,
      errorList: null,
      orderName: this.props.order.orderName,
      orderNameError: null,
      dueDate: this.props.order.dueDateISO,
      dueDateError: null,
      submitted: false
    })
    this.props.onCancelClick()
  }

  getMessages(context) {
    let arr = [
      'c_update_order',
      'c_update',
      'c_cancel',
      'c_order_name',
      'c_due_date'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('ord_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(OrderUpdateModalSF)
